import { render, staticRenderFns } from "./CareerFair.vue?vue&type=template&id=32bc3ad4&scoped=true"
import script from "./CareerFair.vue?vue&type=script&lang=js"
export * from "./CareerFair.vue?vue&type=script&lang=js"
import style0 from "./CareerFair.vue?vue&type=style&index=0&id=32bc3ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bc3ad4",
  null
  
)

export default component.exports